import { action, makeObservable, observable } from 'mobx';
import { initializing, loading, newMessage, ready, State } from './Types';

class ScrollToBottomStore {
  @observable
  state: State = initializing();

  constructor() {
    makeObservable(this);
  }

  @action
  autoScroll = () => {
    switch (this.state.kind) {
      case 'initializing':
        this.load();
        break;
      case 'ready':
        this.newMessage();
        break;
      case 'loading':
      case 'new-message':
        break;
    }
  };

  @action
  initializing = () => {
    this.state = initializing();
  };

  @action
  ready = () => {
    this.state = ready();
  };

  @action
  load = () => {
    this.state = loading();
  };

  @action
  newMessage = () => {
    this.state = newMessage();
  };
}

export default ScrollToBottomStore;
